/**
 * @flow
 * @relayHash c97e7fadfafad95591270dd82b7d1b60
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type privacyPolicyChangeNoticeQueryVariables = {|
  userId: string
|};
export type privacyPolicyChangeNoticeQueryResponse = {|
  +viewer: ?{|
    +doNotShowPrivacyPolicyAlerts: ?boolean,
    +user: ?{|
      +createdDate: ?string
    |},
    +regionalInfo: ?$ReadOnlyArray<?{|
      +countryCode: ?string
    |}>,
  |}
|};
export type privacyPolicyChangeNoticeQuery = {|
  variables: privacyPolicyChangeNoticeQueryVariables,
  response: privacyPolicyChangeNoticeQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "doNotShowPrivacyPolicyAlerts",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "doNotShowPrivacyPolicyAlerts",
      "type": "String!"
    }
  ],
  "storageKey": "isEnabled(key:\"doNotShowPrivacyPolicyAlerts\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "countryCode",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "privacyPolicyChangeNoticeQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "regionalInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "privacyPolicyChangeNoticeQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "regionalInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "privacyPolicyChangeNoticeQuery",
    "id": "dibs-buyer-layout/213.2.1-2019-04-23T05:41:12.419Z/privacyPolicyChangeNoticeQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5ba16820ecdbf712aed3a6a1a19a2c6';
module.exports = node;
